import styled from 'styled-components';

export const Card = styled.a`
  align-items: center;
  width: 150px;
  border-radius: 4px;
  display: flex;
  text-decoration: none;
`;
